import { render } from "./Kitchen.vue?vue&type=template&id=5f1a6c5e&scoped=true"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"

import "./Kitchen.vue?vue&type=style&index=0&id=5f1a6c5e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1a6c5e"]])

export default __exports__